import { Row, Col } from "react-bootstrap";
import ErrorMessageListQAFlags from "./ErrorMessageListQAFlags";
import ErrorMessageAddQAFlags from "./ErrorMessageAddQAFlags";

import React, { useState, useEffect, useCallback } from "react";
import {
  addTransactionQAFlags,
  fetchTransactionQAFlags,
  removeTransactionQAFlags,
  updateTransactionQAFlags,
} from "../services/errorMessageQueue-service";

const ErrorMessageQAFlags = (props) => {
  const [badges, setBadges] = useState([]);
  const [selectedBadge, setSelectedBadge] = useState(null);

  const addOrUpdateBadge = async (badge) => {
    let response = null;
    if (badge.qaFlagId === null) response = await addTransactionQAFlags(badge);
    else response = await updateTransactionQAFlags(badge);

    badge = await response.json();
    let copyBadges = [...badges];
    if (badge.qaFlagId !== null) {
      copyBadges = copyBadges.filter(
        (copyBadge) => copyBadge.qaFlagId !== badge.qaFlagId
      );
    }
    copyBadges.push(badge);

    setBadges(copyBadges);
  };

  const removeQAFlagsData = async (qaFlagId) => {
    let response = await removeTransactionQAFlags(qaFlagId);
    let data = await response.json();
  };

  const removeBadge = (qaFlagId) => {
    removeQAFlagsData(qaFlagId);
    let copyBadges = [...badges];
    copyBadges = copyBadges.filter(
      (copyBadge) => copyBadge.qaFlagId !== qaFlagId
    );
    setBadges(copyBadges);
  };

  const getQAFlagsData = async () => {
    let response = await fetchTransactionQAFlags(props.transactionId);
    let data = await response.json();
    if (data.errorCode !== 404) setBadges(data);
  };

  useEffect(() => {
    badges.length === 0 && getQAFlagsData();
  }, []);

  return (
    <>
      {badges.length > 0 && (
        <ErrorMessageListQAFlags
          badges={badges}
          removeBadge={removeBadge}
          setSelectedBadge={setSelectedBadge}
        />
      )}
      <Row className="errorTxtContainer generalFont ">
        <Col>Add Flags</Col>
      </Row>{" "}
      <ErrorMessageAddQAFlags
        transactionId={props.transactionId}
        addOrUpdateBadge={addOrUpdateBadge}
        selectedBadge={selectedBadge}
      />
    </>
  );
};

export default ErrorMessageQAFlags;
